/* eslint-disable react/no-multi-comp */
import React, { PureComponent } from 'react';
import { routerShape } from 'react-router';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import map from 'lodash/map';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import DataProvider from 'api/data-provider';
import { UserProp } from 'auth';
import Perms from 'auth/perms';
import { emit } from 'helpers/global-events';
import apiDecorator from 'api/api-decorator';
import Form, {
  Input,
  InputArray,
  InputLabel,
  InputDatePicker,
  Checkbox,
  InputSubform,
  InputListBox,
  ImageInput,
  AutocompleteInput
} from 'containers/form';
import visibilityChecker from 'containers/form/visibility-checker';
import InputSelect from 'containers/form/extended/input-select';
import TreeContainer from 'containers/form/extended/tree-container';
import EditorLight from 'containers/form/extended/editor-light';
import LayoutContainer, { Stretch, Fixed } from 'components/layout-container';
import ScrollComponent from 'components/scroll-component';
import TabJSControl from 'components/tab-js-control';
import Row, { Col } from 'components/row';
import Button, { btnThemes } from 'components/button';
import { iconTypes } from 'components/icon';
import Accordion from 'components/accordion';
import { ModalButton, Header, Content } from 'components/modal';
import Notification from 'components/notification';

import AddForumNick from './add-forum-nick';

import ForumIcons from 'src-sites/backoffice/section-admin/forum/help/forum-icons';

// import 'styles/forum/section-forum/_page-club.scss';
import 'styles/forum/common/admin/panel/_admin-panel-forum.scss';

import translates from './add-topic-i18n.json';

const bemClassesAdminPane = new Bem('adminPanelForum');
const classesBemForm = new Bem('modalContentAdmin');
const classesBemInfiniteTree = new Bem('infinite-tree');

// Show form for add new topic.
@apiDecorator
@I18nHoc(translates)
class TopicForm extends PureComponent {
  static propTypes = {
    forum_id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    topic_id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    router: routerShape,
    formChanged: PropTypes.func,
    auth: UserProp,
    checkPermission: PropTypes.func
  };

  // Action for closing modal window
  static contextTypes = {
    close: PropTypes.func.isRequired
  };

  treeItemRenderer =(val)=> { //eslint-disable-line
    const forumTitle = val.forum_title;
    const forumType = val.forum_type;

    return (
      <>
        <ForumIcons {...classesBemInfiniteTree('icon')} forumType={forumType} />
        <span
          {...classesBemInfiniteTree('text')}
          dangerouslySetInnerHTML={{ __html: forumTitle }} // eslint-disable-line
        />
      </>
    );
  }

  onChange =()=> {
    if (typeof this.props.formChanged === 'function') this.props.formChanged();
  }

  onDelete =()=> {
    // TODO: change this to our link builder
    const forumUrlTitle = 'new-club';
    const url = `/clubs/${forumUrlTitle}-c${this.props.forum_id}`;

    this.props.router.push(url);
  }

  onSubmit = (data) => {
    const { i18n } = this;
    emit('updateTopic');
    if (data.topic_id) {
      this.api.get('data/forum/topic', {
        queryString: {
          json: JSON.stringify({
            'topic-id': data.topic_id
          })
        }
      }).then((payload) => {
        const topicUrl = get(payload, 'data[0].topicUrl');
        const topic_published = get(payload, 'data[0].topic_published');
        if (topicUrl && topic_published) {
          Notification.success(i18n('topicPublished'));
          this.props.router.push(topicUrl);
        }
        if (!topic_published) {
          Notification.success(i18n('topicOnModeration'));
        }
      });
    }
  }

  beforeSubmit =()=> {
    if (typeof this.props.formSubmitted === 'function') this.props.formSubmitted();
    this.form.submit();
  }

  renderFormContent =()=> {
    const { i18n } = this;
    const { checkPermission } = this.props;
    const adminPermission = typeof checkPermission === 'function' ?
      checkPermission(Perms.FORUM_CONTROL_ALL_TOPIC) :
      false;

    return (
      <LayoutContainer>
        <Stretch>
          <Row style={{ paddingTop: '2.5rem' }}>
            <Col allPr={0}>
              <Input dataBind="topic_title" />
            </Col>
          </Row>
          {adminPermission &&
            <>
              <Row>
                <Col allPr={0}>
                  <Input dataBind="translations.topic_title:ua" />
                </Col>
              </Row>
              <Row>
                <Col allPr={0}>
                  <div {...classesBemForm('autocompleteInput', 'hAuto')}>
                    <AutocompleteInput
                      dataBind="topic_addition.lc_id"
                      url="admin/location/geocoder"
                      queryWord="suggest"
                      dictKey="id"
                      dictValue="display_path"
                      bindOnlyTips
                      arrayEditor
                      bindNumber
                    />
                  </div>
                </Col>
              </Row>
            </>
          }
          <Row>
            <Col allPr={0}>
              <EditorLight {...classesBemForm('editor')} dataBind="post_text" inForm />
            </Col>
          </Row>
          <Row>
            <Col allPr={0}>
              <InputLabel dataBind="images" />
              <ImageInput dataBind="images" circled />
            </Col>
          </Row>
          <Row allColumn data-visible="tags_first">
            <Col allPr={0}>
              <InputLabel {...classesBemForm('label')} dataBind="tags_first" />
            </Col>
            <Col allPr={0}>
              <div {...classesBemForm('listContainer')}>
                <InputListBox
                  {...classesBemForm('list')}
                  dataBind="tags_first"
                  horizontal
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col allPr={0}>
              <div data-visible="tags_end">
                <InputSelect
                  dataBind="tags_end"
                  url="/forum/tags"
                  queryWord="tag"
                  minLength={2}
                  hasLabel
                  withCreation
                />
              </div>
            </Col>
          </Row>
          <Row allColumn data-visible="topic_status">
            <Col allPr={0}>
              <InputLabel {...classesBemForm('label')} dataBind="topic_status" />
            </Col>
            <Col allPr={0}>
              <div {...classesBemForm('listContainer')}>
                <InputListBox
                  {...classesBemForm('list')}
                  dataBind="topic_status"
                  horizontal
                />
              </div>
            </Col>
          </Row>
          {adminPermission &&
            <Accordion
              panelTopic={i18n('linkTreeForForums')}
              dataView="viewBlockForum"
            >
              <panel>
                <div>
                  <TreeContainer
                    {...classesBemForm('tree')}
                    dataBind="link_tree_for_forums"
                    dataProvider="admin/forum/tree-list"
                    query={{ 'order-by': 'weight' }}
                    itemRenderer={this.treeItemRenderer}
                    loadOnDemand={false}
                    updateEvent="updateForum"
                    multipleSelectionMode
                    staticTreeHeight
                  />
                </div>
              </panel>
            </Accordion>
          }
        </Stretch>
        <Fixed>
          <Row {...classesBemForm('btnsContainer')}>
            <Col allAuto allPr={0}>
              <Button
                data-delete
                label={i18n('delete')}
                theme={btnThemes.red}
                big
              />
            </Col>
            <Col allPr={0} allPl={20}>
              <Row allJustifyCFlexEnd>
                <Col allAuto allPr={0}>
                  <Button
                    onClick={() => this.context.close()}
                    label={i18n('cancel')}
                    theme={btnThemes.light}
                    big
                  />
                </Col>
                <Col allAuto allPr={0} allPl={20}>
                  <Button
                    data-submit
                    label={i18n('publish')}
                    theme={btnThemes.sky}
                    big
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Fixed>
      </LayoutContainer>
    );
  }

  render() {
    const { forum_id } = this.props; // eslint-disable-line
    const otherProps = {};

    otherProps.defaultValues = { forum_id };

    return (
      <Form
        updateEvent={['updateTopic', 'updateClubList', 'updateClubPosts', 'updatePosts', 'updateClubTopics', 'updateContestTopics']}
        ref={el => this.form = el}
        controller="forum/topic-form"
        entityId={this.props.topic_id}
        visibilityChecker={visibilityChecker}
        submitHandler={this.beforeSubmit}
        onSubmit={this.onSubmit}
        onDelete={this.onDelete}
        onChange={this.onChange}
        showPopupValidationMessages
        flexColumn
        hFull
        {...otherProps}
      >
        {this.renderFormContent()}
      </Form>
    );
  }
}

// Form for add/edit votes for specific votes.
@I18nHoc(translates)
export class QuestionsForm extends PureComponent {
  static propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({})),
    topic_id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    forum_id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    maxQuestions: PropTypes.number,
    formChanged: PropTypes.func
  };

  constructor(props, ctx) {
    super(props, ctx);
    this.showQuestions = this.showQuestions.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.onFormDelete = this.onFormDelete.bind(this);

    this.state = {
      renderEmptyForm: false
    };
  }

  componentDidMount() {
    if (!this.props.data.length) this.setState({ renderEmptyForm: true }); // eslint-disable-line
  }

  onFormSubmit() {
    if (this.state.renderEmptyForm) this.setState({ renderEmptyForm: false });
    emit('updateVote');
  }

  onChange =()=> {
    if (typeof this.props.formChanged === 'function') this.props.formChanged();
  }

  onFormDelete() {
    const { data = [], maxQuestions = 1 } = this.props;
    if (data.length === maxQuestions) this.setState({ renderEmptyForm: true });
    emit('updateVote');
  }

  showQuestions(data = {}) {
    const { i18n } = this;
    const { topic_id, forum_id } = this.props;
    const key = data.qid ? `${data.qid}_${data.topic_id}` : 'newForm';
    const otherProps = {};

    otherProps.defaultValues = {
      topic_id,
      forum_id
    };

    return (
      <Accordion
        key={key}
        panelTopic={data.title}
        firstlyOpened={!data.qid}
        dataView="viewBlockForum"
      >
        <panel {...classesBemForm('panel')}>
          <div {...classesBemForm('accordionContent')}>
            <Form
              {...classesBemForm('form')}
              updateEvent="updateQuestion"
              controller="forum/question-form"
              entityId={data.qid || null}
              onSubmit={this.onFormSubmit}
              onDelete={this.onFormDelete}
              onChange={this.onChange}
              showPopupValidationMessages
              hFull
              {...otherProps}
            >
              <Row>
                <Col allPr={0}>
                  <Input dataBind="title" />
                </Col>
              </Row>
              <Row>
                <Col allPr={0}>
                  <AnswersSubform dataBind="answers" />
                </Col>
              </Row>
              <Row mpColumn>
                <Col md={5} mdPr={40} mtCw={45} mtPr={16} mpPr={0}>
                  <Input dataBind="settings.allow_amount_answers" />
                </Col>
                <Col allPr={0} md={7} mtCw={55}>
                  <div>
                    <Checkbox dataBind="settings.allow_change_answer" withIcon noError />
                  </div>
                  <div>
                    <Checkbox dataBind="settings.allow_answered_users" withIcon />
                  </div>
                  <div>
                    <Checkbox dataBind="settings.allow_vote_without_posts" withIcon />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col allPr={0}>
                  <InputDatePicker dataBind="date_off" />
                </Col>
              </Row>
              <Row allJustifyCFlexEnd style={{ paddingBottom: '2rem' }}>
                {!!data.qid &&
                  <Col allAuto allPr={0}>
                    <Button
                      data-delete
                      label={i18n('delete')}
                      theme={btnThemes.light}
                      big
                    />
                  </Col>
                }
                <Col allAuto allPr={0} allPl={20}>
                  <Button
                    data-submit
                    label={i18n('save')}
                    theme={btnThemes.sky}
                    big
                  />
                </Col>
              </Row>
            </Form>
          </div>
        </panel>
      </Accordion>
    );
  }

  render() {
    const { i18n } = this;
    const { data = [], maxQuestions } = this.props;
    const { renderEmptyForm } = this.state;
    let showAddBtn = !renderEmptyForm;

    if (maxQuestions) showAddBtn = showAddBtn && maxQuestions > data.length;

    return (
      <>
        <div {...classesBemForm('accordions')}>
          {map(data, question => this.showQuestions(question))}
          {renderEmptyForm && this.showQuestions({ title: i18n('addPolls') })}
        </div>
        {showAddBtn &&
          <Button
            {...classesBemForm('btn', 'add')}
            iconType={iconTypes.addPlus}
            title={i18n('addPolls')}
            label={i18n('addPolls')}
            onClick={() => this.setState({ renderEmptyForm: true })}
            theme={btnThemes.sky}
          />
        }
      </>
    );
  }
}

// Subform for answers.
// Stateless component for make possible accordion recalculations via context function.
@I18nHoc(translates)
class AnswersSubform extends PureComponent {
  static contextTypes = {
    calcChildOffset: PropTypes.func
  };

  render() {
    const { i18n } = this;
    return (
      <InputArray
        {...this.props}
        addEmptyElementWhenNull
      >
        <div className="inputArray__content">
          <InputSubform
            controller="forum/question-subform"
            arrayEditor
          >
            <Input dataBind="answer" />
          </InputSubform>
          <div className="inputArray__btns">
            <button type="button" title={i18n('delete')} arrayDel />
            <button type="button" title={i18n('recover')} arrayRepair />
            <button
              type="button"
              title={i18n('new')}
              onClick={() => setTimeout(this.context.calcChildOffset, 0)}
              arrayAdd
            />
          </div>
        </div>
      </InputArray>
    );
  }
}

// Form for create and edit topic and votes.
@I18nHoc(translates)
class ForumTopicAdd extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    forum_id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    topic_id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    router: routerShape,
    modalBtnProps: PropTypes.shape({
      onClick: PropTypes.func
    }),
    modalSize: PropTypes.oneOf([
      'small',
      'medium',
      'big',
      'content',
      'full',
      'adminka'
    ]).isRequired,
    hideModalBtn: PropTypes.bool,
    modalHeaderTitle: PropTypes.string,
    auth: UserProp,
    actionDoLogin: PropTypes.func,
    checkPermission: PropTypes.func
  };

  constructor(...props) {
    super(...props);

    this.state = {
      formChanged: false,
      needForumNick: false
    };
  }

  componentDidMount() {
    this.modalBtn = null;
  }

  questionsContent =(id)=> {
    const { i18n } = this;
    if (!id) {
      return (
        <div style={{ paddingTop: '2.5rem' }}>
          <span {...classesBemForm('text')} children={i18n('needToCreateTopic')} />
        </div>
      );
    }

    return (
      <DataProvider
        updateEvent="updateQuestion"
        url="forum/question"
        query={{ 'topic-id': id }}
        injectPropName="data"
      >
        <QuestionsForm
          topic_id={id}
          forum_id={id}
          formChanged={this.formChanged}
        />
      </DataProvider>
    );
  }

  formChanged =()=> {
    this.setState({ formChanged: true });
  }

  modalClosed =()=> {
    this.setState({ formChanged: false });
  }

  needForumNick =()=> {
    this.setState({ needForumNick: true });
  }

  onCloseModalForumNick =()=> {
    this.setState({ needForumNick: false });
  }

  render() {
    const { i18n } = this;
    const { needForumNick } = this.state;
    const {
      className, forum_id, topic_id = null, auth = {}, actionDoLogin,
      modalHeaderTitle, hideModalBtn, modalSize, checkPermission
    } = this.props;

    const modalBtnProps = { ...this.props.modalBtnProps };

    return (
      <>
        {!auth.authenticated &&
          <Button
            {...modalBtnProps}
            onClick={actionDoLogin}
          />
        }
        {auth.authenticated && !auth.forum_nick &&
          <Button
            {...modalBtnProps}
            onClick={this.needForumNick}
          />
        }
        {needForumNick &&
          <AddForumNick
            onCloseModalForumNick={this.onCloseModalForumNick}
          />
        }
        {auth.authenticated && auth.forum_nick &&
          <ModalButton
            ref={el => this.modalBtn = el}
            className={className}
            buttonProps={modalBtnProps}
            size={modalSize}
            hideModalBtn={hideModalBtn}
            askToClose={this.state.formChanged}
            onCloseCallback={this.modalClosed}
            classNameModal={bemClassesAdminPane('modal').className}
          >
            <Header noLine closeButton children={modalHeaderTitle} />
            <Content addPaddingB>
              <ScrollComponent {...classesBemForm()}>
                <TabJSControl tabContentScroll>
                  <tab>
                    <title>{i18n('topicContent')}</title>
                    <TopicForm
                      forum_id={forum_id}
                      topic_id={topic_id}
                      modalBtn={this.modalBtn}
                      router={this.props.router}
                      auth={auth}
                      checkPermission={checkPermission}
                      formSubmitted={this.modalClosed}
                      formChanged={this.formChanged}
                    />
                  </tab>
                  <tab>
                    <title>{i18n('polls')}</title>
                    {this.questionsContent(topic_id)}
                  </tab>
                </TabJSControl>
              </ScrollComponent>
            </Content>
          </ModalButton>
        }
      </>
    );
  }
}

export default ForumTopicAdd;
